import { useEffect, useMemo } from "react";
import debounce from "lodash/debounce";

import { useFlags } from "@stadium/services/launch-darkly/use-flags";

import { pricelessEditCatalogFlag } from "@stadium/services/launch-darkly/constants";

import EditPriceRangeModal from "@stadium/shared/src/components/modals/edit-price-range-modal";

import useFetchPriclessShopTotalBaseProductCount from "@hooks/priceless/use-fetch-total-base-product-count";

const EditShopPriceRangeModal = (props) => {
  const { totalProductsCount, loadingProductCount, getTotalProductCount, taxonLoaded } =
    useFetchPriclessShopTotalBaseProductCount();
  const { [pricelessEditCatalogFlag]: pricelessEditCatalogFlagEnabled } = useFlags();
  const { setPriceRange, defaultPrices } = props;
  const { defaultMinPrice, defaultMaxPrice } = defaultPrices;

  const handlePriceRangeChange = (newPriceRange) => {
    setPriceRange(newPriceRange);
    const debouncedGetTotalProductCount = debounce((newPriceRange) => {
      getTotalProductCount(newPriceRange);
    }, 1000);
    debouncedGetTotalProductCount(newPriceRange);
  };

  useEffect(() => {
    if (taxonLoaded) {
      getTotalProductCount(defaultPrices);
    }
  }, [defaultMaxPrice, defaultMinPrice, taxonLoaded]);

  const headingInfo = useMemo(() => {
    if (pricelessEditCatalogFlagEnabled) {
      return "Only products within your selected price range will be visible to recipients. You can update products and adjust the price range anytime after your shop is created.";
    }
    return `We’ll only include items from all countries that fit this price range. You can
                edit the items and price range at any time after your shop is created.`;
  }, [pricelessEditCatalogFlagEnabled]);

  return (
    <EditPriceRangeModal
      {...props}
      totalProductsCount={totalProductsCount}
      loadingProductCount={loadingProductCount}
      setPriceRange={handlePriceRangeChange}
      headingInfo={headingInfo}
    />
  );
};

export default EditShopPriceRangeModal;
